<script setup lang="ts">
/** The page's outer chrome: centred, width-capped, page gutter. The caller's root supplies flex direction and gap. */
</script>

<template>
  <main class="mx-auto flex w-full max-w-[92.5rem] flex-col p-[var(--space-page)]">
    <slot />
  </main>
</template>
